"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    name: "mvd_782",
    description: "MVD 782-2000 transliteration schema",
    url: "https://dangry.ru/iuliia/mvd-782/",
    mapping: {
        а: "a",
        б: "b",
        в: "v",
        г: "g",
        д: "d",
        е: "e",
        ё: "yo",
        ж: "zh",
        з: "z",
        и: "i",
        й: "y",
        к: "k",
        л: "l",
        м: "m",
        н: "n",
        о: "o",
        п: "p",
        р: "r",
        с: "s",
        т: "t",
        у: "u",
        ф: "f",
        х: "kh",
        ц: "ts",
        ч: "ch",
        ш: "sh",
        щ: "shch",
        ъ: "'",
        ы: "y",
        ь: "'",
        э: "e",
        ю: "yu",
        я: "ya",
    },
    prev_mapping: {
        ае: "ye",
        ее: "ye",
        ёе: "ye",
        ие: "ye",
        ое: "ye",
        уе: "ye",
        ъе: "ye",
        ые: "ye",
        ье: "ye",
        эе: "ye",
        юе: "ye",
        яе: "ye",
        бё: "ye",
        вё: "ye",
        гё: "ye",
        дё: "ye",
        зё: "ye",
        кё: "ye",
        лё: "ye",
        мё: "ye",
        нё: "ye",
        пё: "ye",
        рё: "ye",
        сё: "ye",
        тё: "ye",
        фё: "ye",
        хё: "ye",
        цё: "ye",
        жё: "e",
        чё: "e",
        шё: "e",
        щё: "e",
        ьи: "yi",
    },
    next_mapping: {
        ъе: "",
        ье: "",
        ъё: "",
        ьё: "",
        ьи: "",
    },
    ending_mapping: null,
    samples: [
        [
            "Юлия, съешь ещё этих мягких французских булок из Йошкар-Олы, да выпей алтайского чаю",
            "Yuliya, syesh' eshche etikh myagkikh frantsuzskikh bulok iz Yoshkar-Oly, da vypey altayskogo chayu",
        ],
        ["Юлия Щеглова", "Yuliya Shcheglova"],
        ["Гайа Васильева", "Gaya Vasilyeva"],
        ["Андрей Видный", "Andrey Vidnyy"],
        ["Артём Краевой", "Artyem Krayevoy"],
        ["Мадыр Чёткий", "Madyr Chetkiy"],
        ["Оксана Клеёнкина", "Oksana Kleyonkina"],
        ["Игорь Ильин", "Igor' Ilyin"],
    ],
};
